import {AfterViewInit, Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit, AfterViewInit {

  faq: any[] = [];

  constructor() {
  }

  ngOnInit(): void {

    this.faq = [
      {
        title: 'According to the test results, I have high scores. Does this mean I have a disorder?',
        text: 'The test is not a diagnostic procedure, but it does reveal the possibility of a disorder. If you have a high score based on the results of a certain technique, and the problems related to this concern you to a great extent, we recommend that you contact your family doctor, psychologist or psychiatrist.'
      },
      {
        title: 'I\'m getting mixed results when testing, is the test not working?',
        text: 'The test is not a diagnostic procedure, but it does reveal the possibility of a disorder. If you have a high score based on the results of a certain technique, and the problems related to this concern you to a great extent, we recommend that you contact your family doctor, psychologist or psychiatrist.'
      },
      {
        title: 'The results of the previous tests were better than the new ones. Does this mean that my condition is getting worse?',
        text: 'The test is not a diagnostic procedure, but it does reveal the possibility of a disorder. If you have a high score based on the results of a certain technique, and the problems related to this concern you to a great extent, we recommend that you contact your family doctor, psychologist or psychiatrist.'
      },
      {title: 'asd', text: 'asdasd asdasdasd'},
      {title: 'asd', text: 'asdasd asdasdasd'},
      {title: 'asd', text: 'asdasd asdasdasd'},
    ];


  }

  ngAfterViewInit() {
    // const htmlCode = document.getElementById('acc');
    // const resultJSON = this.htmlToJSON(htmlCode);
  }

  // htmlToJSON(htmlCode) {
  //   const parser = new DOMParser();
  //   const doc = parser.parseFromString(htmlCode, 'text/html');
  //
  //   const panels = doc.querySelectorAll('ngb-panel');
  //
  //   const jsonArray = [];
  //
  //   panels.forEach((panel) => {
  //     const title = panel.querySelector('h5').innerText;
  //     const content = panel.querySelector('.card-body').innerHTML;
  //
  //     jsonArray.push({title, text: content});
  //   });
  //
  //   return jsonArray;
  // }
}
